import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { EDIT_QUOTAION } from "../apollo/mutations";
import { LIST_PRODUCTS, QUOTATION_DETAIL } from "../apollo/queries";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";
import closeModal from "../common/closeModal";
import { showErrorToast } from "../utils";
// import { showErrorToast } from "../utils";

const useEditQuotation = ({ rowData, refetch }) => {
  const [manipulatedProducts, setManipulatedProducts] = useState([]);
  const defaultValues = {
    id: rowData?.id,
    customer_id: rowData?.customer?.id,
    warehouse_id: rowData?.warehouse?.id,
    status: rowData?.status,
    order_tax: rowData?.order_tax,
    discount: rowData?.discount,
    shipping: rowData?.shipping,
    description: rowData?.description,
    order_products: [],
  };

  const { data } = useQuery(QUOTATION_DETAIL, {
    variables: {
      getOrderId: rowData?.id,
    },
    skip: !rowData?.id,
    fetchPolicy: "network-only",
  });

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });

  const {
    fields: products,
    append: appendProducts,
    remove: removeProducts,
  } = useFieldArray({
    control,
    name: "order_products",
  });

  const order_products = useWatch({
    control,
    name: "order_products",
  });

  const warehouse_id = useWatch({
    control,
    name: "warehouse_id",
  });

  const [fetchProducts, { data: productsData }] = useLazyQuery(LIST_PRODUCTS);

  useEffect(() => {
    if (warehouse_id) {
      fetchProducts({
        variables: {
          storeId: getSelectedStoreDetails("id"),
          warehouseId: warehouse_id,
        },
      });
    }
  }, [warehouse_id]);

  useEffect(() => {
    if (productsData?.listProduct) {
      // Manipulate the product data here
      const transformedProducts = productsData.listProduct.map((product) => ({
        value: product.id,
        label: product.name,
        images: product.images,
        price: product.price,
      }));
      setManipulatedProducts(transformedProducts);
    }
  }, [productsData]);

  useEffect(() => {
    if (rowData && data?.getOrder) {
      defaultValues.quotation_date = data?.getOrder?.quotation_date;
      defaultValues.order_products = data?.getOrder?.order_products?.map(
        (item) => ({
          id: item?.id,
          productName: item?.product?.name,
          quantity: item?.quantity,
          price: item?.price,
          product_id: item?.product?.id,
          images: item?.product?.images?.[0],
        })
      );
      reset(defaultValues);
    }
  }, [rowData, data]);

  const [submit] = useMutation(EDIT_QUOTAION);

  const onEditQuotation = async (data) => {
    try {
      console.log("data", data);
      console.log("data", data.order_products);
      const invalidProduct = data.order_products.find(
        (item) =>
          item.price == "" || item.price == "0" || item.price === undefined
      );

      if (invalidProduct) {
        showErrorToast("Please enter a valid product price");
        return;
      }

      const invalidQty = data.order_products.find(
        (item) =>
          item.quantity == "" ||
          item.quantity == "0" ||
          item.quantity === undefined
      );

      if (invalidQty) {
        showErrorToast("Please enter a valid product quantity");
        return;
      }
      delete data.product_id;
      const order_products = data.order_products.map(
        ({ id = null, product_id, quantity, price }) => ({
          id,
          product_id,
          quantity: parseInt(quantity),
          price: parseFloat(price),
        })
      );
      delete data.order_products;
      delete data.customer_id;
      delete data.warehouse_id;
      const payload = {
        ...data,
        order_products,
        order_tax: parseFloat(data?.order_tax),
        discount: parseFloat(data?.discount),
        shipping: parseFloat(data?.shipping),
      };
      console.log("payload Data", payload);
      await submit(payloadValidator(payload));
      reset(defaultValues);
      refetch();
      closeModal("edit-units");
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    closeModal("edit-units");
  };

  return {
    values: {
      control,
      errors,
      products,
      order_products,
      productsData: manipulatedProducts,
    },
    getValues,
    refetch,
    functions: {
      onSubmit: handleSubmit(onEditQuotation),
      onCancel,
      appendProducts,
      removeProducts,
    },
  };
};

export default useEditQuotation;
